import { render, staticRenderFns } from "./PersonalProfileComponent.vue?vue&type=template&id=65b4e48a"
import script from "./PersonalProfileComponent.vue?vue&type=script&lang=js"
export * from "./PersonalProfileComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports